import { Component, signal, inject } from '@angular/core';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { MenuItem } from '../../core/models/sidebar.js';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatDividerModule } from '@angular/material/divider';
import { SidebarService } from '../../core/services/sidebar.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [
    MatListModule,
    MatIconModule,
    RouterLink,
    RouterLinkActive,
    MatSidenavModule,
    MatDividerModule,
    TranslateModule
  ],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent {
  private sidebarService = inject(SidebarService);

  menuItems = signal<MenuItem[]>([]);

  constructor() {
    this.menuItems = signal(this.sidebarService.getMenuItems());
  }

  toggleSubmenu(item: MenuItem) {
    this.menuItems().forEach(menuItem => {
      if (menuItem !== item) {
        menuItem.showSubmenu = false;
      }
    });
    if (item.submenu) {
      item.showSubmenu = !item.showSubmenu;
    }
  }

  isSubmenuOpen(item: MenuItem): boolean {
    return item.showSubmenu;
  }
}